import Api from "..";

const alterarSenha = async (idUsuario, novaSenha) => {
    try {
        const response = await Api.put("login/alterar-senha", { 
            idUsuario, 
            novaSenha 
        });
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao alterar senha: ${error.message}`);
    }
};

export default {
    alterarSenha
};
